import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import styels from "../../styles/components/editorPendingFilter.module.scss";
import React, { useEffect } from "react";
import CalenderIcon from "../../public/assets/icons/CalenderIcon";
import useCalenderFilter from "../../hooks/useCalenderFilter";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import {
  setFrom,
  setTo,
} from "../../redux-toolkit/slices/editor/editorPendingPublication.slice";
import dayjs from "dayjs";
import styled from "@emotion/styled";
import { getDateApiFormat } from "../../lib/functions/utils.lib";
import CalenderDate from "../../pages/Calender";
import { useLocation, useNavigate } from "react-router";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 8,
    marginTop: "5px",
    minWidth: "129px",
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
    "& .MuiMenu-list": {
      padding: "11px 5px !important",
    },
    "& .MuiMenuItem-root": {
      fontWeight: "500",
      fontSize: "14px",
      color: "#7D7D7D",
      padding: "1px 3px",
      borderRadius: "5px",
      marginBottom: "3px",
      "&.Mui-selected": {
        background: "#F3F3F3",
      },
      "&:hover": {
        color: "#4b4b4b",
        background: "#F3F3F3",
      },
      "&:active": {
        background: "#F3F3F3",
        borderRadius: "5px",
      },
    },
  },
}));

const EditorPendingFilter = ({
  data,
  hideDateRangeFilter,
  leftItems,
  handleTriggreFetch,
}) => {
  const calenderContainerId = "calender-input-filter-row";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    calenderOpen,
    resetCalender,
    confirmCalender,
    confirmCalenderTwo,
    confirmedCalenderValue,
    calenderValue,
    setCalenderValue,
    toggleCalender,
    closeCalender,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderContainerId,
  });

  const dispatch = useAppDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const urgent_requestValue = queryParams.get("urgent_posting_request");
  const navigate = useNavigate();

  const handleRemoveUrgentRequest = () => {
    navigate("/editor-dashboard/editor-pending-publication");
    handleTriggreFetch();
  };

  const handleUrgentRequest = () => {
    navigate("?urgent_posting_request=yes");
    handleTriggreFetch();
  };

  useEffect(() => {
    if (calenderValue) {
      if (calenderValue[0]) {
        dispatch(setFrom(getDateApiFormat(calenderValue[0]["$d"])));
      }
      if (calenderValue[1]) {
        dispatch(setTo(getDateApiFormat(calenderValue[1]["$d"])));
      }

      handleTriggreFetch();
    }
  }, [calenderValue]);

  return (
    <Box className={styels.editorFilterWrapper}>
      <Box className={styels.editorFilterWrapperTxt}>
        {/* <Typography variant='body1'>Showing videos for <span>All Time</span></Typography>
                <Typography variant='body1' className={styels.dateShow}>(April 23, 2023 - Today)</Typography> */}
        {!hideDateRangeFilter ? (
          <Box>
            {leftItems}

            <Box className="commonSearchBar_modal">
              <p>
                Showing Videos for 
                {calenderFilter ? (
                  <>
                    <Box
                      className={`dayList ${openedDateRangeFilter ? "date-black" : "date-blue"
                        }`}
                    >
                      <Button
                        aria-haspopup="true"
                        onClick={handleOpenDateRangeFilter}
                      >
                        {calenderFilter?.name}
                      </Button>
                      <StyledMenu
                        anchorEl={dateRangeFilterAnchor}
                        open={openedDateRangeFilter}
                        onClose={handleCloseDateRangeFilter}
                      >
                        {/* {DateFilterRangeList.slice(1).map((filter) => (
                            <MenuItem
                              onClick={changeCalenderFilter(filter)}
                              key={filter.name}
                              selected={filter === calenderFilter}
                            >
                              {filter.name}
                            </MenuItem>
                          ))} */}
                        {DateFilterRangeList.map((filter) => {
                          if (filter != calenderFilter) {
                            return (
                              <MenuItem
                                onClick={changeCalenderFilter(filter)}
                                key={filter.name}
                                selected={filter === calenderFilter}
                              >
                                {filter.name}
                              </MenuItem>
                            );
                          }
                        })}
                      </StyledMenu>
                    </Box>
                    <span className="dateList">
                      ({calenderFilterShowValue})
                    </span>
                  </>
                ) : (
                  <>
                    the period from 
                    {confirmedCalenderValue?.[0] ? (
                      <span>
                        {dayjs(confirmedCalenderValue?.[0]).format("LL")}
                      </span>
                    ) : null}
                    to
                    {calenderValue?.[1] ? (
                      <span>
                        {dayjs(confirmedCalenderValue?.[1]).format("LL")}
                      </span>
                    ) : null}
                  </>
                )}
              </p>
              {/* {calenderFilter?.name !== "Today" ? ( */}
              {calenderFilter?.name !== "All time" ? (
                <span className="reset_picker" onClick={resetCalender}>
                  {/* <span className="reset_picker" onClick={handleResetCalender}> */}
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                      stroke="currentColor"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M4.22705 6.7832L6.77263 4.23762"
                      stroke="currentColor"
                      strokeWidth="0.8"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M6.77263 6.76238L4.22705 4.2168"
                      stroke="currentColor"
                      strokeWidth="0.8"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  reset
                </span>
              ) : null}
            </Box>
          </Box>
        ) : null}
      </Box>

      <Box className={styels.editorFilterButtonGroup}>
        {urgent_requestValue ? (
          // use this button for active color
          <Button
            className={`${styels.metaUpdate} ${styels.metaUpdateActive}`}
            onClick={handleRemoveUrgentRequest}
          >
            <span>Urgent Postings</span>
          </Button>
        ) : (
          <Button className={`${styels.metaUpdate}`} onClick={handleUrgentRequest}>
            <span>Urgent Postings</span>
          </Button>
        )}
        <Box className={styels.editorFilterCalender}>
          <CalenderDate confirmCalender={confirmCalenderTwo} />
        </Box>
        <Button className={styels.allVideo}>
          All videos: <span>{data?.total}</span>
        </Button>
      </Box>
    </Box>
  );
};

export default EditorPendingFilter;
